<template>
  <v-app id="inspire">
    <v-navigation-drawer
      v-model="drawer"
      :clipped="$vuetify.breakpoint.lgAndUp"
      app
    >
      <v-list dense>
        <template v-for="item in menus">
          <v-row v-if="item.heading"
           :key="item.heading"

            align="center">
            <v-col cols="6">
              <v-subheader v-if="item.heading">
                {{ item.heading }}
              </v-subheader>
            </v-col>
            <v-col cols="6" class="text-center">
              <a href="#!" class="body-2 black--text">EDIT</a>
            </v-col>
          </v-row>
          <v-list-group
            v-else-if="item.children"
            :key="item.text"
            v-model="item.model"

            :prepend-icon="item.model ? item.icon : item['icon-alt']"
            append-icon="expand_less"
          >
            <template v-slot:activator>
              <v-list-item class="parent" >
                <v-list-item-content>
                  <v-list-item-title>
                    {{ item.text }}
                  </v-list-item-title>
                </v-list-item-content>
              </v-list-item>
            </template>
            <v-list-item
              class="child"
              v-for="(child, i) in item.children"
              :key="i"
              :to="child.to"
              @click="lancarNotaDe(child.text)"
            >
              <v-list-item-action v-if="child.icon">
                <v-icon>{{ child.icon }}</v-icon>
              </v-list-item-action>
              <v-list-item-content>
                <v-list-item-title>
                  {{ child.text }}
                </v-list-item-title>
              </v-list-item-content>
            </v-list-item>
          </v-list-group>
          <v-list-item v-else :key="item.text" @click="method(item.to)">
            <v-list-item-action>
              <v-icon>{{ item.icon }}</v-icon>
            </v-list-item-action>
            <v-list-item-content>
              <v-list-item-title>
                {{ item.text }}
              </v-list-item-title>
            </v-list-item-content>
          </v-list-item>
        </template>
      </v-list>
    </v-navigation-drawer>

    <v-app-bar
      :clipped-left="$vuetify.breakpoint.lgAndUp"
      app
      color="blue darken-3"
      dark
    >
      <v-toolbar-title style="width: 300px" class="ml-0 pl-4">
        <v-app-bar-nav-icon @click.stop="drawer = !drawer">
          <v-icon>menu</v-icon></v-app-bar-nav-icon
        >
        <span class="hidden-sm-and-down">Eltsys</span>
      </v-toolbar-title>

      <v-btn icon large>
        <v-avatar size="42px" item>
          <v-img
            class="hidden-sm-and-down"
            src="http://esaudeluanda.com/images/logo.jpg"
            alt="Vuetify"
          >
          </v-img>

          <span class="hidden-sm-and-down"> EFTSL - </span>
          <span class="hidden-sm-and-down" style="font-size:10px">
            Anolectivo: {{ anolectivo }}</span
          >
        </v-avatar>
      </v-btn>
      <v-spacer></v-spacer>
      <v-btn icon large>
        <v-avatar size="42px" item>
          <v-container>
            <v-row>
              <v-col cols="12" sm="6"> </v-col>
            </v-row>

            <v-row>
              <v-col cols="12" sm="6">
                <span class="hidden-sm-and-down pb-0" style="font-size:14px">
                  {{ instituicaodescricao }}</span
                >
              </v-col>

            </v-row>

          </v-container>
        </v-avatar>
      </v-btn>
      <v-spacer></v-spacer>

        <v-btn color="green">
           0
            <v-icon>mail</v-icon>

        </v-btn>
      <v-spacer></v-spacer>

<template>
  <div class="text-center" width="800px">
    <v-menu offset-y>
      <template v-slot:activator="{ on }">
        <v-btn icon v-on="on">
        <v-icon>account_circle</v-icon>
      </v-btn>
      </template>
      <v-card width="300">
        <v-list>
          <v-list-item>
            <v-list-item-avatar>
              <v-icon color="#006699" style="font-size:50px;margin-top:-75px;">account_circle</v-icon>
            </v-list-item-avatar>

            <v-list-item-content>
              <v-list-item-title style="font-weight:bold;">{{loggedUserName}}</v-list-item-title>
              <v-list-item-subtitle>{{loggedEmail}}</v-list-item-subtitle>
              <v-list-item-subtitle>
                 <v-row style="margin-top:20px;">
                   <v-col md="3">
                     <v-tooltip bottom>
                          <template v-slot:activator="{ on, attrs }">
                            <v-btn small fab color="#006699" style="margin-left:15px;color:white;"
                              v-bind="attrs"
                              v-on="on"
                            >
                                    <v-icon small>vpn_key</v-icon>
                              </v-btn>
                          </template>
                          <span>Clique aqui para alterar a sua Palavra-Passe</span>
                      </v-tooltip>

                   </v-col>
                   <v-col md="3">
                      <v-tooltip bottom>
                          <template v-slot:activator="{ on, attrs }">
                           <v-btn small fab color="#006699" style="color:white;margin-left:-2px;" v-bind="attrs" v-on="on">
                              <v-icon small>desktop_mac</v-icon>
                            </v-btn>
                          </template>
                          <span>Clique aqui para saber mais sobre o sistema Eltsys e a versão que está a utilizar.</span>
                      </v-tooltip>

                   </v-col>
                   <v-col md="3">
                      <v-tooltip bottom>
                          <template v-slot:activator="{ on, attrs }">
                            <v-btn small fab color="#006699" style="color:white;margin-left:-20px;" v-bind="attrs" v-on="on">
                                 <v-icon small>location_on</v-icon>
                            </v-btn>
                          </template>
                          <span>Saiba a sua localização, clicando aqui!</span>
                      </v-tooltip>

                   </v-col>
                 </v-row>
              </v-list-item-subtitle>
            </v-list-item-content>
          </v-list-item>
        </v-list>

        <v-list>
          <v-divider></v-divider>
          <v-list-item @click="">
            <v-list-item-action>
              <v-icon>info</v-icon>
            </v-list-item-action>
            <v-list-item-title>Sobre nós</v-list-item-title>
          </v-list-item>
          <v-divider></v-divider>
        <v-list-item @click="$router.push('licencaStatus')" v-if="(role === 'ROLE_ADM') ||(role === 'ROLE_PED') ">
            <v-list-item-action>
              <v-icon>payments</v-icon>
            </v-list-item-action>
            <v-list-item-title>Licença</v-list-item-title>
          </v-list-item>
           <v-divider></v-divider>
          <v-list-item @click="Call_Sair()">
            <v-list-item-action>
              <v-icon>logout</v-icon>
            </v-list-item-action>
            <v-list-item-title>Terminar Sessão</v-list-item-title>
          </v-list-item>
        </v-list>
      </v-card>
    </v-menu>
  </div>
</template>
<template>
  <v-dialog v-model="dialogo" fullscreen hide-overlay transition="dialog-bottom-transition" >

      <v-card>
        <v-toolbar color="blue darken-3"
      dark>
          <v-btn icon dark @click="dialogo = false">
            <v-icon>close</v-icon>
          </v-btn>
          <v-toolbar-title><v-btn dark text @click="dialogo = false">Fechar </v-btn></v-toolbar-title>
          <v-spacer></v-spacer>
          <v-toolbar-items>
            <v-btn dark text @click="logout()"><v-icon>logout</v-icon>Sair</v-btn>
          </v-toolbar-items>
        </v-toolbar>
         <v-list>
        <v-row >
          <v-col cols="2"><v-subheader>Usuários Activos</v-subheader></v-col>
          <v-col cols="1"><v-btn @click="MostraUsuariosActivos()"><v-icon color="green" >cached</v-icon></v-btn></v-col>
          <v-col cols="4">

              <v-progress-circular
              v-if="progresso"
                    color="green"
                    indeterminate
                  ></v-progress-circular>

          </v-col>
        </v-row>
        <v-row>
            <v-col col="4">
              <v-list-item
                v-for="(item, i) in usuarios"
                :key="i"
              >

                    <v-list-item-icon>
                    <v-icon v-if="item.status === 'on'" small color="green">fiber_manual_record</v-icon>
                    <v-icon v-if="item.status === 'off'" small color="orange">fiber_manual_record</v-icon>
                    </v-list-item-icon>
                    <v-list-item-content>
                    <v-list-item-title small >{{item.nome}}-<span style="font-size:10px;color:grey;">{{item.instituicao}}</span></v-list-item-title>
                    <v-list-item-title v-if="item.status === 'on'" small style="font-size:12px;color:grey;">Online a <span style="font-size:12px;color:grey;">{{MostraHoraMinuto(CalculoDosMinutos(new Date(item.data_in)-new Date(item.data_sistema)))}}</span></v-list-item-title>
                    <v-list-item-title v-if="CalculoDosMinutos(new Date(item.data_in)-new Date(item.data_sistema)) === 0 " small style="font-size:12px;color:grey;">Online agora</v-list-item-title>
                    <v-list-item-title v-if="item.status === 'off'" small style="font-size:12px;color:grey;">Inativo a {{MostraHoraMinuto(CalculoDosMinutos(new Date(item.data_in)-new Date(item.data_sistema)))}} minutos</v-list-item-title>
                   </v-list-item-content>

            </v-list-item>
              </v-col>
            </v-row>

    </v-list>
      </v-card>
    </v-dialog>
</template>

    </v-app-bar>

    <!--  ./assets/material.webp -->
    <v-content
      class="circular"
      v-bind:style="{
        backgroundImage:
          'url( https://cdn.vuetifyjs.com/images/parallax/material.jpg )'
      }"
    >
     <router-view />

    </v-content>
  </v-app>
</template>

<script>
import axios from './plugins/axios'
import utilitarios from './plugins/utilitarios'
var ls = require('local-storage')
export default {
  data: () => ({
    menus: [],
    clicked: 0,
    dialog: false,
    progresso: false,
    daysLeft: '',
    usuarios: [],
    activos: true,
    drawer: null,
    dialogo: false,
    Mostrar_usuario: false,
    items2: [
      { text: 'Real-Time', icon: 'account_circle' },
      { text: 'Audience', icon: 'account_circle' },
      { text: 'Conversions', icon: 'account_circle' }

    ],

    items: [

      //= ==========================Itens de Menu Geral para todos usuarios==============================//
      { text: 'Home', icon: 'dashboard', to: 'welcome', role: 'all' },
      { text: 'Sobre o Sistema', icon: 'question_answer', to: 'about', role: 'all' },
      { icon: 'contacts', text: 'Contacts', to: 'contacto', role: 'all' },
      { icon: 'shopping_cart', text: 'Relatório Pagamento mensal', to: 'PagamentoMensal', role: 'func' },
      { icon: 'list_alt', text: 'Imprimir Pauta', to: 'menu-pauta', role: 'func' },
      //= ==========================Itens de Menu Geral para todos usuarios==============================//

      //= ==Itens de Menu Para usuarios com role de Funcionarios , logo, os usuarios acima deste poderão tambem ver estes items ==============================//
      { icon: 'import_export', text: 'Exportação', to: 'painelclassesExportacao', role: 'func' },
      {
        icon: 'remove',
        'icon-alt': 'add',
        text: 'Aulas',
        model: false,
        role: 'est',
        children: [
          { icon: 'add_box', text: 'Publicar Aulas', to: 'sumarios-publicados' },
          { icon: 'desktop_windows', text: 'Assistir aula', to: 'disciplinas-do-aluno' }
        ]
      },

      { icon: 'remove',
        'icon-alt': 'add',
        text: 'Gerir Funcionário',
        model: false,
        role: 'func',
        children:
        [
          { icon: 'person_add', text: 'Cadastrar', to: 'funcionario' },
          { icon: 'search', text: 'Pesquisar', to: 'funcionario-pesquisa' }
        ]
      },
      { icon: 'remove',
        'icon-alt': 'add',
        text: 'Gerir Professor',
        model: false,
        role: 'func',
        children:
        [
          { icon: 'person_add', text: 'Novo Professor', to: 'funcionario' },
          { icon: 'person', text: 'Atriuir turma', to: 'professor' },
          { icon: 'search', text: 'Pesquisar', to: 'Professor-disciplina-search' }
        ]
      },
      { icon: 'remove',
        'icon-alt': 'add',
        text: 'Gerir Estudante',
        model: false,
        role: 'func',
        children: [
          { icon: 'person_add', text: 'Novo Estudante', to: 'painelclasses' },
          { icon: 'crop_rotate', text: 'Transferir Estudante', to: 'transferencia' },
          { icon: 'search', text: 'Pesquisa por Classe', to: 'painelclasses-search' },
          { icon: 'image_search', text: 'Pesquisa Geral', to: 'estudante-pesquisa-geral' },
          { icon: 'system_update_alt', text: 'Mudança de Classe', to: 'mudar-classe' },
          { icon: 'view_headline', text: 'Listar solições de mudança', to: 'pedido-mudanca-estudante' }
        ]
      },
      { icon: 'remove',
        'icon-alt': 'add',
        text: 'Gerir Turma',
        model: false,
        role: 'func',
        children: [
          { icon: 'add_box', text: 'Professor/Turma', to: 'professor' },
          { icon: 'list_alt', text: 'Listar Turmas', to: 'painelClassTurma' }
        ]
      },
      { icon: 'remove',
        'icon-alt': 'add',
        text: 'Gerir Coordenador',
        model: false,
        role: 'ped',
        children: [
          { icon: 'person_add', text: 'Cadastrar', to: 'cadastrar-coordenador' },
          { icon: 'search', text: 'Pesquisar', to: 'coordenador-pesquisar' }
        ]
      },
      { icon: 'remove',
        'icon-alt': 'add',
        text: 'Confirmar Matricula',
        model: false,
        role: 'func',
        children: [
          { icon: 'person_add', text: 'Enquadramento', to: 'enquadramento' },
          { icon: 'list_alt', text: 'Listar Turmas', to: 'painelClassTurma' }
        ]
      },

      //= ===========================================================================================
      //= =================Itens de Menu referente apenas para usuarios com role de Professor ou acima  ============================================================

      { icon: 'remove',
        'icon-alt': 'add',
        text: 'Lançar notas',
        model: false,
        to: 'painelgerirturmas',
        role: 'prof',
        children: [
          { icon: 'filter_1', text: '1º Trimestre', to: 'lancar-trimestre-um' },
          { icon: 'filter_2', text: '2º Trimestre', to: 'lancar-trimestre-dois' },
          { icon: 'filter_3', text: '3º Trimestre', to: 'lancar-trimestre-tres' },
          { icon: 'school', text: 'Exame', to: 'NotaExame' },
          { icon: 'collections', text: 'Nota Finalista', to: 'NotaFinalista' },
          { icon: 'exposure', text: 'Nota Votada', to: 'Nota-votada' }
        ]
      },

      //= ==================================================================

      //= ====================== Itens de Menu para o usuario com o role de padagogico e acima =======================
      { text: 'Estatística', icon: 'timeline', to: 'menu-estatistica', role: 'dir' },
      { icon: 'remove',
        'icon-alt': 'crop_rotate',
        text: 'Transferência',
        model: false,
        role: 'ped',
        children: [
          { icon: 'fast_forward', text: 'Solicitar', to: 'transferencia' },
          { icon: 'fast_rewind', text: 'Pedidos de Transferência', to: 'pedidos-transferencia' }
        ]
      },
      /*  { icon: 'remove',
        'icon-alt': 'airline_seat_legroom_extra',
        text: 'Cadeira em atraso',
        model: false,
        role: 'ped',
        children: [
          { icon: 'tab', text: 'Listar Cadeirantes', to: 'cadeira' },
          { icon: 'tab', text: 'Lançar notas cadeira', to: 'notasCadeira', role: 'ped' }
        ]
      }, */

      { icon: 'remove',
        'icon-alt': 'search',
        text: 'Pesquisa',
        model: false,
        role: 'ped',
        children: [
          { icon: 'search', text: ls.get('instituicaodescricao'), to: 'estudante-pesquisa-geral' },
          { icon: 'image_search', text: 'Em outros colégios', to: 'pesquisaGlobal' }

          // { icon: 'receipt', text: 'Solicitações Mudança', to: 'pedido-mudanca-estudante' }

        ]
      },
      { role: 'ped', icon: 'clear_all', text: 'Lista de Finalistas', to: 'estudantes-finalistas-pesquisa' },
      { role: 'dir', icon: 'developer_board', text: 'Estudantes fora de Epoca', to: 'estudantes-fora-epoca' },
      {
        icon: 'build',
        'icon-alt': 'build',
        text: 'Administrador',
        model: false,
        role: 'adm',
        children: [
          { icon: 'assignment_turned_in', text: 'Gerar Licença', to: 'GerarLicenca' },
          { icon: 'open_with', text: 'Abertura e Fecho de Ano Lectivo', to: 'abrir-fechar-anolectivo' },
          { icon: 'query_builder', text: 'Mudar de Época', to: 'MudarEpoca' },
          { icon: 'home_work', text: 'Mudar de Instituição', to: 'Mudar_instituicao' },
          { icon: 'fiber_new', text: 'Cadastrar Nova Instituição', to: 'CadastrarInstituicao' },
          { icon: 'change_history', text: 'Operações Estudante', to: 'mudancas-estudante' },
          { icon: 'settings', text: 'Pedidos de Mudança', to: 'pedidos-mudancas-admin' },
          { icon: 'search', text: 'Pesquisa Global', to: 'pesquisaGlobal' },
          { icon: 'search', text: 'Transitação', to: 'transitacao' },
          { icon: 'settings', text: 'Operação Instituição', to: 'operacoes-instituicao' },
          { icon: 'remove_red_eye', text: 'Monitoração', to: 'controlo-actividades' },
          { icon: 'note_add', text: 'Lançar notas Ano anterior', to: 'lancar-notas-anos-anteriores' },
          { icon: 'bookmarks', text: 'Preparar Certificado', to: 'preparar-certificado-admin' }

        ]
      },
      { icon: 'restore_from_trash', text: 'Lixeira', to: 'Estudante-lixeira', role: 'func' },
      { text: 'Preparar Certificado', icon: 'note_add', to: 'preparar-certificado', role: 'func' },
      { text: 'Estudantes fora Turma', icon: 'dns', to: 'estudantes-foraTurma', role: 'func' },
      { text: 'Minha(s) turma(s)', icon: 'card_travel', to: 'minhas-turmas', role: 'prof' },
      { icon: 'lock', text: 'Permissões', role: 'func', to: 'senhas-painel' },
      { icon: 'home_work', text: 'Mudar de Instituição', to: 'Mudar_instituicao', role: 'dir' },
      { icon: 'search', text: 'Pesquisa Global', to: 'pesquisaGlobal', role: 'dir' },
      { text: 'Meu Perfil', icon: 'account_circle', to: 'perfil', role: 'all' },
      { icon: 'help', text: 'Ajuda', role: 'all', to: 'no-available' },
      { icon: 'logout', text: 'Sair', to: 'logout', role: 'all' }

    ]
  }),

  onIdle () {
    this.logout()
    this.messageStr = 'zzz'
  },

  onActive () {
    this.messageStr = 'Activo'
  },
  methods: {
    carregamenu () {
      const role = ls.get('role')
      if (role === 'ROLE_DIR') {
        this.menus = this.items.filter(m => m.role === 'all' || m.role === 'func' || m.role === 'prof' || m.role === 'ped' || m.role === 'dir'
        )
      } else if (role === 'ROLE_PED') {
        this.menus = this.items.filter(m => m.role === 'all' ||
      m.role === 'ped' ||
      m.role === 'coor' ||
      m.role === 'func' ||
      m.role === 'prof' ||
      m.role === 'est'
        )
      } else if (role === 'ROLE_ADM') {
        this.menus = this.items.filter(m => m.role === 'all' ||
      m.role === 'ped' ||
      m.role === 'coor' ||
      m.role === 'func' ||
      m.role === 'prof' ||
      m.role === 'est' ||
      m.role === 'adm' ||
      m.role === 'dir'
        )
      } else if (role === 'ROLE_COOR') {
        this.menus = this.items.filter(m => m.role === 'all' ||

      m.role === 'coor' ||
      m.role === 'func' ||
      m.role === 'prof' ||
      m.role === 'est'
        )
      } else if (role === 'ROLE_FUNC') {
        this.menus = this.items.filter(m => m.role === 'all' ||

            m.role === 'func' ||

            m.role === 'est'
        )
      } else if (role === 'ROLE_PROF') {
        this.menus = this.items.filter(m => m.role === 'all' ||

      m.role === 'prof' ||
      m.role === 'est'
        )
      } else if (role === 'ROLE_EST') {
        this.menus = this.items.filter(m => m.role === 'all' ||

      m.role === 'est'
        )
      } else if (role === 'ROLE_PWR') {
        this.menus = this.items.filter(m => m.role === 'all' ||
            m.role === 'ped' ||
            m.role === 'coor' ||
            m.role === 'func' ||
            m.role === 'prof' ||
            m.role === 'est'
        )
      }
    },

    CalculoDosMinutos (millisec) {
      var minutes = (millisec / (1000 * 60)).toFixed(1)
      // var hours = (millisec / (1000 * 60 * 60)).toFixed(1); //
      return Math.round(Math.abs(minutes))
    },

    MostraHoraMinuto (valor) {
      let minuto = valor % 60
      let hora = Math.round(valor / 60)

      let resultado = ''
      if (hora >= 1) {
        resultado = hora + ' hora e ' + minuto + ' minutos'
      } else {
        resultado = minuto + ' minutos'
      }

      return resultado
    },
    async Call_Sair () {
      /* this.MostraUsuariosActivos()

      const params = {
        loginUpdate: 1,
        username: '',
        nome: '',
        datain: '',
        dataout: this.ObterDataTimeRemote(),
        autor: ls.get('nomeUsuario'),
        loginpkCode: ls.get('uuid'),
        instituicao: '',
        role: '',
        latitude: '',
        longitude: ''

      }

      try {
        let msg = await axios
          .post('/InsertOrUpdateLoginLogs', params)
          .then(res => res.data)
      } catch (error) {

      }
*/
      // Logout
      ls.remove('token')
      ls.clear()
      this.$router.push('/')
    },

    Meu_perfil () {
      this.$router.push('/perfil')
    },

    async MostraUsuariosActivos () {
      this.progresso = true
      try {
        this.usuarios = await axios
          .get('/usuarios-activos')
          .then(res => res.data)
        this.progresso = false
        console.log('executou')
      } catch (error) {
        this.isLoading = false
        this.progresso = false
        this.text = error
        this.$store.dispatch('textMessage', {
          msg: this.text,
          classMessage: 'msgError',
          timeout: 3000
        })
      }
    },

    UsuariosActivos () {
      this.MostraUsuariosActivos()
      this.dialogo = true
    },

    ObterDataTimeRemote () {
      var today = new Date()
      var day = today.getDate() + ''
      var month = (today.getMonth() + 1) + ''
      var year = today.getFullYear() + ''
      var hour = today.getHours() + ''
      var minutes = today.getMinutes() + ''
      var seconds = today.getSeconds() + ''

      day = checkZero(day)
      month = checkZero(month)
      year = checkZero(year)
      hour = checkZero(hour)
      minutes = checkZero(minutes)
      seconds = checkZero(seconds)

      return (year + '-' + month + '-' + day + ' ' + hour + ':' + minutes + ':' + seconds)

      function checkZero (data) {
        if (data.length === 1) {
          data = '0' + data
        }
        return data
      }
    },

    lancarNotaDe (param) {
      if (this.clicked < 1) {
        this.clicked = 1
      }

      if (param.includes('Trimestre')) {
        const payload = [
          { param: param, idperfilpauta: param.substring(0, 1) }
        ]
        this.$store.dispatch('lancarNotaDe', payload)
      }
    },
    isLoggedUSer () {
      if (!ls.get('token')) {
        this.$router.push('/')
      }
    },

    method (param) {
      if (param.includes('logout')) {
        this.Call_Sair()
      } else {
        this.$router.push('/' + param)
      }
    },
    async logout () {
      // chama o uuid
      // Actualiza o status do usuario
      this.Call_Sair()
      this.MostraUsuariosActivos()
      ls.remove('token')
      ls.clear()
      this.$router.push('/')
    }
  },

  props: {
    source: String
  },
  computed: {
    instituicaodescricao () {
      return ls.get('instituicaodescricao')
    },
    anolectivo () {
      return ls.get('anolectivo')
    },
    loggedUserName () {
      return ls.get('nomeUsuario')
    },
    loggedEmail () {
      return ls.get('username')
    },
    role () {
      return ls.get('role')
    }
  },

  created () {
    this.carregamenu()
    this.isLoggedUSer()
  }
}
</script>
<style scoped>
.parent {
  padding: 0px
}
.child {
  margin-left: 40px;
  background-color: beige;
}
</style>
